module.exports = __webpack_public_path__ + "static/media/prep-artwork.b0c183ac.png";